var render = function render(){var _vm=this,_c=_vm._self._c;return _c('the-table-page',{attrs:{"titleTable":_vm.$t('Бренды'),"tableData":_vm.tableData,"load":_vm.load,"fieldId":"id","updateData":_vm.updateData,"fieldInfoList":_vm.fieldInfoList,"searchStart":_vm.searchStart,"sortData":_vm.sortData,"setSort":_vm.setSort,"deleteEl":_vm.deleteEl,"roleName":_vm.nameRoleEntity}})
}
var staticRenderFns = []

export { render, staticRenderFns }